// extracted by mini-css-extract-plugin
export default {"popup":"unstoppablePopup_popup__3FUyj","content":"unstoppablePopup_content__QhuT1","aboveText":"unstoppablePopup_aboveText__8232v"};